import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./SASS/style.scss";
import App from "./App";
import AppConfig from "./AppConfig";
import AppSDK from "@growthos/ui-app-sdk";

import "./SASS/style.scss";

const appBasePath = AppConfig.getAppBasePath();
const appElementId = "app";

const renderApp = (
	<AppSDK.ShellProvider onRender={handler_render}>
		<AppSDK.ErrorHandler>
			<BrowserRouter basename={appBasePath}>
				<App />
			</BrowserRouter>
		</AppSDK.ErrorHandler>
	</AppSDK.ShellProvider>
);

function handler_render(app) {
	const appEl = document.getElementById(appElementId);
	createRoot(appEl).render(app);
}
handler_render(renderApp);
